import React from 'react';
import { LocaleProvider } from '../contexts/locale/LocaleProvider';
import { getCountryConfigFromCode } from '../domain/country/helper';
import { getCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import { Country, PerLanguageConfig } from '../domain/country/type';
import { LoadingSpinner } from '../base-components';
import { captureException } from '../ts-utils/analytics/sentry/Sentry';

export interface LocaleProviderProps {
  children: React.ReactNode;
}

export const LocaleProviderWrapper: React.FC<LocaleProviderProps> = ({
  children,
}) => {
  const [localeData] = React.useState<{
    country: Country;
    configs: PerLanguageConfig;
  } | null>(() => {
    if (typeof window === 'undefined') {
      return null;
    }

    const locale = getCookie('NEXT_LOCALE');
    if (!locale) return null;

    const [langPart, countryPart] = locale.split('-');
    const countryCode = countryPart?.toLowerCase() ?? 'bd';
    const country = getCountryConfigFromCode(countryCode);
    if (!country) return null;
    const configs = country.languages[langPart?.toLowerCase() || 'en'];
    return {
      country,
      configs,
    };
  });

  if (!localeData?.country || !localeData?.configs) {
    console.error('Failed to load locale data');
    captureException('Failed to load locale data in LocaleProviderWrapper');
    return <LoadingSpinner className="absolute inset-0 m-auto" />;
  }

  return (
    <LocaleProvider
      value={{
        country: localeData?.country,
        configs: localeData?.configs,
      }}
    >
      {children}
    </LocaleProvider>
  );
};

export default LocaleProviderWrapper;
